import React, {Component} from 'react';
import PropTypes from 'prop-types';
import translate from '../../services/translation';
import {AddFavouritesApp} from "../../apps/AddFavouritesApp";
import NumberFormat from 'react-number-format';
import LinesEllipsis from "react-lines-ellipsis";
import LabelPopup from "./LabelPopup";

export default class ExcursionItem extends Component {

    static propTypes = {
        favouriteItem: PropTypes.object,
        onRemove: PropTypes.func,
        favouriteLink: PropTypes.string
    };

    render() {
        const {favouriteItem, onRemove, favouriteLink} = this.props;

        return (
            <div className="favouriteItemWrapper excursionItem">
                <div className="favouriteItemContainer">
                    <div className="favouriteItemRowImage">
                        <a href={favouriteItem.detailPageUrl}>
                            {favouriteItem.travelarea &&
                                <span className="favouriteItemTravelarea">
                                {favouriteItem.travelarea}
                            </span>
                            }

                            <div className="favouriteItemImage">
                                <img alt={favouriteItem.title} src={favouriteItem.listImageUrl} onError={(event) => event.target.style.display = 'none'} />
                            </div>
                        </a>
                    </div>

                    <div className="favouriteItemRowText">

                        {favouriteItem.label.length > 0 && (
                            <LabelPopup labels={favouriteItem.label} />
                        )}

                        <AddFavouritesApp excursionUid={favouriteItem.uid} favouriteType='excursion' favouriteLink={favouriteLink} />

                        {onRemove &&
                        <div className="favouriteItemRemove">
                            <button onClick={() => onRemove(favouriteItem.uid)}>
                                <span className="removeButtonText hiddenText">{translate('favourite.close')}</span>
                                <span className="removeButtonIcon"/>
                            </button>
                        </div>
                        }

                        <div className="favouriteItemTextWrapper">
                            <a href={favouriteItem.detailPageUrl}>
                                {favouriteItem.category &&
                                    <div className="favoriteItemCategory">
                                        {favouriteItem.category}
                                    </div>
                                }

                                {favouriteItem.ltrKey &&
                                    <div className="favoriteItemLtr">
                                        {favouriteItem.ltrKey}
                                    </div>
                                }

                                <div className="favouriteItemHeadline">
                                    <h2>{favouriteItem.title}</h2>
                                </div>

                                {favouriteItem.description &&
                                    <div className="favouriteItemText">
                                        <LinesEllipsis
                                            text={favouriteItem.description}
                                            maxLine='3'
                                            ellipsis='...'
                                            trimRight
                                            basedOn='letters'
                                        />
                                    </div>
                                }

                                <div className="favouriteItemInfo">
                                    {favouriteItem.duration !== 0 &&
                                        <div className="favouriteItemDuration">
                                            <span>
                                                {favouriteItem.duration}&nbsp;{favouriteItem.duration === 1 ? translate('excursion_item.hours').slice(0, -1) : translate('excursion_item.hours')}
                                            </span>
                                        </div>
                                    }

                                    {favouriteItem.weekdays.length > 0 &&
                                        <div className="favouriteItemWeekdays">
                                            {favouriteItem.weekdays.map(weekday => <span className="favouriteItemWeekday">{weekday}</span>)}
                                        </div>
                                    }

                                    {favouriteItem.price !== 0 ?
                                        <div className="favouriteItemPrice">
                                            <span className="fromPriceText">{translate('itinerary_item.from')}</span>
                                            <span className="fromPrice"><NumberFormat prefix={'Fr. '} value={favouriteItem.price} displayType='text' thousandSeparator={"'"} suffix={'.-'} /></span>
                                            <span className="fromPriceInfo">
                                                {favouriteItem.priceLabel ? favouriteItem.priceLabel : translate('itinerary_item.price_per_person')}
                                            </span>
                                        </div>
                                        :
                                        <span className="fromPriceInfo">{translate('itinerary_item.price_on_request')}</span>
                                    }
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Favourites/ExcursionItem.js